module.exports = __webpack_public_path__ + "img/12_pc.5aa9b196.gif";